import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 레이아웃 요소(Header, Sidebar 등)의 표시 여부를 결정하는 커스텀 훅
 * 특정 경로에서는 레이아웃을 숨깁니다.
 *
 * @returns {boolean} 레이아웃 표시 여부
 */
const useLayoutVisibility = () => {
  const location = useLocation();
  const [showLayout, setShowLayout] = useState(true);

  // 레이아웃을 숨길 경로 목록
  const hiddenPaths = ['/pos/review', '/attendance'];

  useEffect(() => {
    const shouldHide = hiddenPaths.some((path) =>
      location.pathname === path || location.pathname.startsWith(path + '/')
    );
    setShowLayout(!shouldHide);
  }, [location.pathname]);

  return showLayout;
};

export default useLayoutVisibility;
